export const SELECT_CATEGORY_OPTIONS = [
    { value: 'Thời sự', label: 'Thời sự' },
    { value: 'Thế giới', label: 'Thế giới' },
    { value: 'Pháp luật', label: 'Pháp luật' },
    { value: 'Kinh doanh', label: 'Kinh doanh' },
    { value: 'Công nghệ', label: 'Công nghệ' },
    { value: 'Xe', label: 'Xe' },
    { value: 'Du lịch', label: 'Du lịch' },
    { value: 'Nhịp sống trẻ', label: 'Nhịp sống trẻ' },
    { value: 'Văn hóa', label: 'Văn hóa' },
    { value: 'Giải trí', label: 'Giải trí' },
    { value: 'Thể thao', label: 'Thể thao' },
    { value: 'Giáo dục', label: 'Giáo dục' },
    { value: 'Khoa học', label: 'Khoa học' },
    { value: 'Sức khỏe', label: 'Sức khỏe' },
    { value: 'Giả-Thật', label: 'Giả-Thật' },
    { value: 'Bạn đọc', label: 'Bạn đọc' },
]